// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2zesn","visuallyhidden":"_2nRLz","hide-text":"_1doqy","center":"_3p5x6","noprint":"_2_bHX","subtitle":"_1OTM5"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-subtitle/styles/Subtitle.scss
 ** module id = 953
 ** module chunks = 1
 **/